import React, {Component} from 'react';
import {Row, Col, Progress, Card, CardHeader,CardBlock, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import {ajaxWrapperPost, ajaxWrapperGet, ajaxWrapperDelete} from '../../../utils/deviceAPI';
import LoadingIndicator from '../../../utils/LoadingIndicator';
import UsersNotificationSystem from './UsersNotificationSystem';


const defaultAddNewuser = {
    addNewUseremail: "",
    addNewUserfirstname: "",
    addNewUserlastname: "",
    addNewUserpassword: "",
    addNewUsertel: "",
    addNewUserdealer: "",
    addNewUsercontrol: false,
    modifyUsercontrol: false,
    addUserFormValid: false,
    addNewUseremailValid: false,
    addNewUserfirstnameValid: false,
    addNewUserlastnameValid: false,
    addNewUserpasswordValid: false,
    addNewUsertelValid: false,
    formMessage: {
        addNewUseremail: "",
        addNewUserfirstname: "",
        addNewUserlastname: "",
        addNewUserpassword: "",
        addNewUsertel: ""
    }
};

class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };

    }
    componentDidMount() {

    }
    componentWillUnmount(){

    }

    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }

        return (
            <div className="animated fadeIn">
                <Row>
                    <Col xs="12" lg="6">
                        <Card>
                            <CardBody className="card-body">
asd
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>


        )
    }
}

export default Users;



// WEBPACK FOOTER //
// ./src/views/Admin/Users/Users.js